const style = {
  gutterBottom: {
    marginBottom: 8
  }
}

export default style